import React from 'react'
import PropTypes from 'prop-types';
import "./index.css";
import _ from "underscore";

// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const DatesCategory = ({ blocks, context }) => {
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent context={context} key={blockKey}/>
    ));

    if (childBlocks.length > 0) {
        return (
            <category name='Dates' iconclass='category with-icon-paths snap-icon-date_picker_dual'>{/* NOSONAR */}
                <label text="Dates"/>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }
    
    return null;
};

DatesCategory.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
};

export default DatesCategory;
